export default __webpack_public_path__ + "static/media/bb3.1.d464c5ab.png";